import { FilterConfig, FilterElement, FiltersList } from './types';
import AssetGroupsFilter from '@casops/side-panels/filter-panel/filters/asset-groups/AssetGroupsFilter';
import ConfigGroupsFilter from '@casops/side-panels/filter-panel/filters/config-groups/ConfigGroupsFilter';
import DeviceTypesFilter from '@casops/side-panels/filter-panel/filters/device-types/DeviceTypesFilter';
import SoftwareStatusFilter from '@casops/side-panels/filter-panel/filters/software-status/SoftwareStatusFilter';
import HealthStatusFilter from '@casops/side-panels/filter-panel/filters/health-status/HealthStatusFilter';
import ObjectTypesFilter from '@casops/side-panels/filter-panel/filters/object-types/ObjectTypesFilter';
import GeofenceStateFilter from '@casops/side-panels/filter-panel/filters/geofence-state/GeofenceStateFilter';
import GeofenceTypesFilter from '@casops/side-panels/filter-panel/filters/geofence-types/GeofenceTypesFilter';
import GeofenceStylesFilter from '@casops/side-panels/filter-panel/filters/geofence-styles/GeofenceStylesFilter';
import GeofenceAreasFilter from '@casops/side-panels/filter-panel/filters/geofence-areas/GeofenceAreasFilter';

export const FILTERS_CONFIG: FilterConfig[] = [
  {
    name: 'assetGroups',
    FilterComponent: AssetGroupsFilter,
    elementType: FilterElement.VdsDropdownMultiselect,
  },
  {
    name: 'configGroups',
    FilterComponent: ConfigGroupsFilter,
    elementType: FilterElement.VdsDropdownMultiselect,
  },
  {
    name: 'deviceTypes',
    FilterComponent: DeviceTypesFilter,
    elementType: FilterElement.VdsDropdownMultiselect,
  },
  {
    name: 'geofenceAreas',
    FilterComponent: GeofenceAreasFilter,
    elementType: FilterElement.VdsDropdownMultiselect,
  },
  {
    name: 'geofenceState',
    FilterComponent: GeofenceStateFilter,
    elementType: FilterElement.VdsDropdown,
  },
  {
    name: 'geofenceStyles',
    FilterComponent: GeofenceStylesFilter,
    elementType: FilterElement.VdsDropdownMultiselect,
  },
  {
    name: 'geofenceTypes',
    FilterComponent: GeofenceTypesFilter,
    elementType: FilterElement.VdsDropdownMultiselect,
  },
  {
    name: 'healthStatus',
    FilterComponent: HealthStatusFilter,
    elementType: FilterElement.VdsDropdown,
  },
  {
    name: 'objectTypes',
    FilterComponent: ObjectTypesFilter,
    elementType: FilterElement.VdsDropdownMultiselect,
  },
  {
    name: 'softwareStatus',
    FilterComponent: SoftwareStatusFilter,
    elementType: FilterElement.VdsDropdown,
  },
];

/* Filter Groups */

export const ASSET_LIST_FILTERS: FiltersList = [
  'assetGroups',
  'deviceTypes',
  'objectTypes',
  'configGroups',
  'softwareStatus',
  'healthStatus',
];

export const GEOFENCE_FILTERS: FiltersList = [
  'assetGroups',
  'geofenceTypes',
  'geofenceAreas',
  'geofenceStyles',
  'geofenceState',
];
